/* eslint-disable react/display-name */
/**
 *
 * FormularioPreguntas
 *
 */

import { memo } from 'react';

import { lazyLoad } from 'utils/loadable';

import { PenaltiesRouting } from './penalties.routing';
interface Props {}

export const PenaltiesComponent = memo((props: Props) => {
  return (
    <>
      <PenaltiesRouting />
    </>
  );
});

export const PenaltiesModule = lazyLoad(
  () => import('./penalties.module'),
  (module) => module.PenaltiesComponent
);
